import { Stack, Text } from "@mantine/core"

import {
  CommunicationStudioClasses,
  CUSTOMISATION_CATEGORIES,
} from "@tfg/types/constants/communication-studio.constant"
import { AGECResponses } from "@tfg/types/endpoints/agec"
import { titleColorCSSVariable } from "@tfg/types/schemas/communication-studio/cssVariables"

import { useGetStylingParametersContext } from "../context/stylingParameters/useGetStylingParametersContext"
import { DesignStudioParametersToolkit } from "../utils/designStudioParametersToolkit"

export type OrganizationTitleProps = {
  agecData: AGECResponses.GenericAgecData
}

export const OrganizationTitle = ({ agecData }: OrganizationTitleProps) => {
  const { stylingParameters } = useGetStylingParametersContext()

  if (!agecData.organizationName) {
    return null
  }

  return (
    <Stack
      c={DesignStudioParametersToolkit.getCssVariableLiteralName(
        titleColorCSSVariable
      )}
    >
      <Text
        className={CommunicationStudioClasses.ORGANIZATION_TITLE}
        style={{
          ...DesignStudioParametersToolkit.spreadStylingParameters({
            category: CUSTOMISATION_CATEGORIES.GLOBAL,
            stylingParameters,
            stylingParamKeys: ["letterSpacing"],
          }),
        }}
      >
        {agecData.organizationName}
      </Text>
    </Stack>
  )
}
